import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dictionary",
  "use": "icon-dictionary-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dictionary\"><path d=\"M188.188444 56.888889v910.222222H56.888889V56.888889h131.299555zM967.111111 163.498667v697.116444C967.111111 919.438222 918.755556 967.111111 859.022222 967.111111H244.736V56.888889H859.022222c59.733333 0 108.088889 48.128 108.088889 106.609778z m-321.080889 125.383111h-80.213333l-176.64 436.337778h86.471111l48.128-119.011556h164.124444l48.241778 119.011556h86.471111l-176.583111-436.337778zM605.866667 403.342222l49.891555 123.505778H555.861333l50.062223-123.505778z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dictionary.svg
// module id = YRIb
// module chunks = 78